import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDebounce } from "../../../../../resources/js/hooks/useDebounce";

const SearchKeywordBar = (props) => {
    const {
        isLoading,
        searchKeyword,
        setSearchKeyword,
        onCancelClick,
    } = props;

    const [keyword, setKeyword] = useState(searchKeyword || '');
    const debouncedKeyword = useDebounce(keyword, 1000);
    useEffect(() => {
        setSearchKeyword(debouncedKeyword);
    }, [debouncedKeyword]);

    return (
        <div className="d-inline-block d-flex align-items-center bg-black bg-opacity-25 px-2 rounded w-100">
            <span className="h4 text-muted m-0">
                {isLoading ? (
                    <div className="spinner-border spinner-border-sm text-primary" role="status"
                         style={{ width: "24px", height: "26px" }}>
                        <span className="sr-only">Loading...</span>
                    </div>
                ) : (
                    <i className="fas fa-solid fa-magnifying-glass"/>
                )}
            </span>
            <input
                id="main-search-input"
                className="bg-transparent form-control rounded border-0 shadow-none text-white"
                type="text"
                value={keyword || ''}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="Search through OAP database"
                autoComplete="off"
            />

            <button className="btn btn-link" onClick={onCancelClick}>
                <span className="h4 text-white">
                    <i className="fa-solid fa-xmark"/>
                </span>
            </button>
        </div>
    );
};

SearchKeywordBar.propTypes = {
    isLoading: PropTypes.bool,
    searchKeyword: PropTypes.string,
    setSearchKeyword: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
};

SearchKeywordBar.defaultProps = {
    isLoading: false,
};

export default SearchKeywordBar;
